import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorsHandleService } from '../errors-handle.service';
import { ResponseService } from 'src/app/types/type';
import { catchError, retry } from 'rxjs';

enum methods {
  DuplicarCheckList = 'DuplicarCheckList',
}

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient, private errorHandle: ErrorsHandleService) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  postDuplicarCheckList(idCheckList: number, nombre: string) {
    const body = { idCheckList, nombre };
    return this.http.post<ResponseService>(`${this.URL}${methods.DuplicarCheckList}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.errorHandle.handleError)
      );
  }
}
